import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=40f0c82b&scoped=true"
import script from "./customList.vue?vue&type=script&lang=js"
export * from "./customList.vue?vue&type=script&lang=js"
import style0 from "./customList.vue?vue&type=style&index=0&id=40f0c82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0c82b",
  null
  
)

export default component.exports